import React, { useState } from "react";
import { Search2Icon } from "@chakra-ui/icons";
import {
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { sortBy } from "lodash";

import {
  AcatsContraBroker,
  useAcatsContraBrokers,
} from "../../../api/acats/listAcatsContraBrokers";
import {
  FilterButton,
  FilterDrawer,
  FilterSelect,
} from "../../../components/filter";
import Header from "../../../components/layout/Header";

import AcatsContraBrokersTable from "./AcatsContraBrokersTable";

type FilterForm = {
  [K in keyof AcatsContraBroker]?: string;
};

const BROKER_TYPE_OPTIONS = ["All", "BANK", "BROKER"];

const AcatsContraBrokers = (): JSX.Element => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  const [query, setQuery] = useState("");
  const [filters, setFilters] = useState<FilterForm>({});
  const [appliedFilters, setAppliedFilters] = useState<FilterForm>({});

  const { data, isLoading } = useAcatsContraBrokers();
  const contraBrokers = sortBy(data, (broker) => broker.name) ?? [];

  const onSearchChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setQuery(event.target.value);
  };

  const applyFilter = () => {
    setAppliedFilters(filters);
    onClose();
  };

  const removeFilter = (key: string) => {
    setAppliedFilters((filters) => ({
      ...filters,
      [key]: undefined,
    }));
  };

  const openFilter = () => {
    setFilters(appliedFilters);
    onOpen();
  };

  const closeFilter = () => {
    onClose();
  };

  const setFilterValue = (key: string, value: string) => {
    setFilters((filters) => ({
      ...filters,
      [key]: value === "All" ? undefined : value,
    }));
  };

  return (
    <>
      <Header title="ACATS > Contra Brokers" />
      <Flex justifyContent="flex-end" alignItems="center">
        <InputGroup maxWidth="300px">
          <InputLeftElement>
            <Search2Icon color={useColorModeValue("dark.900", "light.900")} />
          </InputLeftElement>
          <Input
            bg="gray.200"
            name="search"
            placeholder="Search Name, DTC Number"
            onChange={onSearchChange}
            variant="filled"
          />
        </InputGroup>
        <FilterButton
          filterPills={appliedFilters}
          openFilter={openFilter}
          removeFilter={removeFilter}
        />
      </Flex>
      <AcatsContraBrokersTable
        data={contraBrokers}
        filters={appliedFilters}
        isLoading={isLoading}
        query={query}
      />
      <FilterDrawer isOpen={isOpen} onClose={closeFilter} onApply={applyFilter}>
        <FilterSelect
          header="Type"
          options={BROKER_TYPE_OPTIONS}
          onSelect={(value) => setFilterValue("type", value)}
          selected={filters.type ?? "All"}
          noOptionFmt
        />
      </FilterDrawer>
    </>
  );
};

export default AcatsContraBrokers;
